function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { useDirection, usePrefixCls } from '@byte-design/config';
import { useChildrenEnterLeave } from '../../hooks/animation';
import { CloseOne } from './../../common/icons';

var useInputAddOn = function useInputAddOn(type, node) {
  var cls = usePrefixCls(type);
  return node ? React.createElement("span", {
    className: cls
  }, node) : null;
};

export var RenderSelectedWrapper = function RenderSelectedWrapper(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      children = props.children,
      suffix = props.suffix,
      focus = props.focus,
      disabled = props.disabled,
      inputRef = props.inputRef,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? false : _props$clearable,
      _props$outlined = props.outlined,
      outlined = _props$outlined === void 0 ? true : _props$outlined,
      onClear = props.onClear,
      _props$innerClassName = props.innerClassName,
      innerClassName = _props$innerClassName === void 0 ? '' : _props$innerClassName,
      _props$unsetHeight = props.unsetHeight,
      unsetHeight = _props$unsetHeight === void 0 ? true : _props$unsetHeight;
  var rtl = useDirection() === 'rtl';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var handleMouseEnter = useRefCallback(function () {
    return setHover(true);
  });
  var handleMouseLeave = useRefCallback(function () {
    return setHover(false);
  });
  var wrapperCls = classnames(usePrefixCls('input-wrapper', {
    size: size,
    rtl: rtl
  }), usePrefixCls('select-render-selected', {
    'unset-height': unsetHeight
  }));
  var suffixCls = usePrefixCls('input-suffix');
  var clearCls = classnames(usePrefixCls('input-close-icon'), suffixCls);
  var suffixElement = useInputAddOn('input-suffix', suffix);
  var innerWrapperCls = classnames(usePrefixCls('input-inner__wrapper', {
    border: Boolean(outlined),
    size: size,
    hover: hover,
    focus: focus,
    disabled: disabled,
    warning: invalid,
    'add-suffix': !!(suffix || clearable),
    rtl: rtl
  }), innerClassName);
  var onClick = useRefCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClear === null || onClear === void 0 ? void 0 : onClear();
  });

  var renderSuffix = function renderSuffix() {
    var clear = clearable && hover && React.createElement(CloseOne, {
      theme: "filled",
      className: clearCls
    });

    if (!disabled && children && React.isValidElement(clear)) {
      return React.cloneElement(clear, {
        onClick: onClick,
        key: 'clear'
      });
    }

    var realSuffix = suffixElement;

    if (React.isValidElement(realSuffix)) {
      return React.cloneElement(realSuffix, {
        key: 'suffix'
      });
    }

    return realSuffix;
  };

  var _useChildrenEnterLeav = useChildrenEnterLeave(renderSuffix(), {
    duration: 100,
    childRefKey: null,
    enterTick: function enterTick() {
      return void 0;
    },
    ignoreInitialRender: true,
    skipChildWithoutRef: false,
    enterChildProps: {
      'data-motion-fade': 'in'
    },
    leaveChildProps: {
      'data-motion-fade': 'out'
    }
  }),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedSuffix = _useChildrenEnterLeav2[0],
      startAnimation = _useChildrenEnterLeav2[1];

  useEffect(startAnimation);
  return React.createElement("div", {
    className: wrapperCls,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: inputRef
  }, React.createElement("div", {
    className: innerWrapperCls
  }, children, animatedSuffix));
};